import { useRouter } from "@tanstack/react-router"
import { AlertCircleIcon } from "lucide-react"
import { useEffect } from "react"

import { Alert, AlertDescription, AlertTitle, Button } from "@atlant/ui"

import { faro } from "#faro.ts"

export const DefaultRouteError = ({ error }: { error: Error }) => {
  const router = useRouter()

  useEffect(() => {
    faro?.api.pushError(error, { context: { source: "route-error" } })
  }, [error])

  return (
    <div className="flex h-full items-center justify-center p-4">
      <Alert variant="destructive" className="max-w-md shadow-lg">
        <AlertCircleIcon className="h-5 w-5" />
        <AlertTitle className="mb-2">Something went wrong</AlertTitle>
        <AlertDescription className="space-y-3">
          <p className="text-sm">{error.message}</p>
          <Button
            variant="outline"
            size="sm"
            onClick={() => router.invalidate()}
            className="w-full"
          >
            Try again
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  )
}
